<ndt-account-active-dates-view
   [form]="form"
   [callState]="callState$ | async"
   [account]="account"
   [title]="title"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onConfirm()"
></ndt-account-active-dates-view>
